import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import moment from 'moment';
const canceledBannerCss = "cjrc7so";
const isEventEndInPast = event => {
  if (!event.endTime) return false;
  const end = moment(event.endTime);
  return moment().isAfter(end);
};
const CanceledBanner = ({
  cancellation
}) => <ContextualBanner variant="danger" className={canceledBannerCss}>
    <p><strong>{cancellation.attribution}</strong></p>
    <p>{cancellation.reason}</p>
  </ContextualBanner>;
const RescheduledBanner = ({
  cancellation
}) => <ContextualBanner variant="standard">
    <p><strong>{I18n.t('publisher.meetings.info_banner.rescheduled_by', {
        name: cancellation.cancelledBy
      })}</strong></p>
    <p>{cancellation.reason.replace(I18n.t('publisher.dashboard.event.rescheduled_prefix'), '')}</p>
  </ContextualBanner>;
const LocationErrorBanner = ({
  externalLocation
}) => <ContextualBanner variant="danger" icon={AlertWarningTriangleIcon}>
    <strong>{I18n.t('publisher.meetings.info_banner.action_needed')}</strong>
    {': '}
    {HtmlParser(externalLocation.errorNotice)}
  </ContextualBanner>;
export const InfoBanner = ({
  event
}) => {
  const {
    cancelled,
    newSchedulable,
    externalLocation,
    cancellation
  } = event;
  const isCancelled = cancelled && cancellation;
  const isRescheduled = isCancelled && !!newSchedulable;
  const hasLocationError = externalLocation?.showLocationIssue;
  if (isCancelled && !isRescheduled) {
    return <CanceledBanner cancellation={cancellation} />;
  }
  if (isRescheduled) {
    return <RescheduledBanner cancellation={cancellation} />;
  }
  if (hasLocationError && !isEventEndInPast(event)) {
    return <LocationErrorBanner externalLocation={externalLocation} />;
  }
  return null;
};

require("./info_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./info_banner.js");